// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const clothBolt = defineModel({
  id: "cloth-bolt",
  batchId: "future",
  name: "Cloth bolt",
  tags: ["scenery","cloth","bolt","low-poly","age-of-mcp","future"],
  summary: "Bolts of woven cloth — clothing, sacks, sails and bandages.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.4,
  parts: () => [
      { geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.34, 10), color: "#9b4a4a", position: [-0.16, 0.08, 0.04], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.128, 0.012, 0.112), color: "#9b4a4a", position: [-0.16, 0.056, 0.23], rotation: [0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.34, 10), color: "#3f6a8a", position: [0, 0.08, 0.06], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.128, 0.012, 0.112), color: "#3f6a8a", position: [0, 0.056, 0.25], rotation: [0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.08, 0.08, 0.34, 10), color: "#6f8a44", position: [0.16, 0.08, 0.04], rotation: [1.570796, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.128, 0.012, 0.112), color: "#6f8a44", position: [0.16, 0.056, 0.23], rotation: [0.5, 0, 0] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.3, 10), color: "#b08a3a", position: [-0.08, 0.23, -0.06], rotation: [1.570796, 0, 0.1] },
      { geometry: new THREE.BoxGeometry(0.112, 0.012, 0.098), color: "#b08a3a", position: [-0.08, 0.209, 0.11], rotation: [0.5, 0, 0.1] },
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.3, 10), color: "#7a4a7a", position: [0.08, 0.23, -0.06], rotation: [1.570796, 0, -0.1] },
      { geometry: new THREE.BoxGeometry(0.112, 0.012, 0.098), color: "#7a4a7a", position: [0.08, 0.209, 0.11], rotation: [0.5, 0, -0.1] },
    ],
  animations: [],
});
